import { format } from "date-fns";
import { parseDate } from "@/lib/dates";
import { TRUNCATE_DEFAULT, DATE_FORMAT_SHORT } from "@/lib/constants";

/**
 * Truncate a string with ellipsis if it exceeds `max` characters.
 */
export function truncateText(s: string, max: number = TRUNCATE_DEFAULT): string {
  return s.length > max ? s.slice(0, max) + "..." : s;
}

/**
 * Format a duration in seconds to a human-readable string (e.g. "2m 15s").
 */
export function formatDuration(seconds?: number): string {
  if (!seconds) return "-";
  const SECONDS_PER_MINUTE = 60;
  const m = Math.floor(seconds / SECONDS_PER_MINUTE);
  const s = Math.round(seconds % SECONDS_PER_MINUTE);
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}

/**
 * Replace underscores with spaces for display (e.g. "pbm_closed" → "pbm closed").
 */
export function formatEnumLabel(s: string): string {
  return s.replace(/_/g, " ");
}

/**
 * Join first and last name, filtering out empty values.
 */
export function formatPersonName(first?: string, last?: string): string {
  return [first, last].filter(Boolean).join(" ");
}

/**
 * Safely parse and format a date value from any source (Firestore timestamp,
 * ISO string, unix epoch) into a display string.
 *
 * Returns "-" if the value cannot be parsed.
 */
export function formatDate(value: unknown, fmt: string = DATE_FORMAT_SHORT): string {
  const d = parseDate(value);
  if (!d) return "-";
  try {
    return format(d, fmt);
  } catch {
    return "-";
  }
}
